import React from "react";
import { RestaurantAddress } from "./RestaurantAddress";

// Component to club all the details related to a restaurant. For example, details such as photos, menu,
// reviews, and overview
export const RestaurantDetails = (props) => {
  const restaurant = props.restaurant;
  return (
    <div className="row">

      <div className="row">
        <div className="row">
          <div className="col-12 col-lg-6 col-xl-6 col-xxl-6">
              <div className="card-body ms-0 ps-0">
                <h4 className="card-title">Cuisines</h4>
                <p className="card-text">
                  <ul className="btn-group">
                    {restaurant.cuisines.map((cuisine) => (
                      <li className="btn btn-outline-primary">{cuisine} </li>
                    ))}{" "}
                  </ul>
                </p>
              </div>

          </div>
          <div className="col-lg-6 col-xl-6 col-xxl-6"/>
        </div>
        <div className="row">   
            <div className="card-body" >

                <h4 className="card-title">Opens at</h4>
                <div className="ps-4">
                    <p className=" card-text btn btn-outline-dark ps-4">
                        {restaurant.hours}
                    </p>
                </div>


            </div>
        </div>
      </div>
    </div>
  );
};
